import { GA4Event } from '@jusbrasil-web/shared-ga4'

import { EVENT } from '../constants'

export type LoginAuthenticationMethod =
  | 'jusbrasil_form'
  | 'google_authentication'
  | 'password_change'

export interface GA4LoginEventProps {
  authentication_method: LoginAuthenticationMethod
  successful_attempt: boolean
}

export class GA4LoginEvent extends GA4Event {
  authentication_method: GA4LoginEventProps['authentication_method']
  successful_attempt: GA4LoginEventProps['successful_attempt']

  constructor({ authentication_method, successful_attempt }: GA4LoginEventProps) {
    super({ event: EVENT.LOGIN })

    this.authentication_method = authentication_method
    this.successful_attempt = successful_attempt
  }
}
